module.exports = __webpack_public_path__ + "static/media/products-landing-hero-mobile-750x380.71df1cbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/products/assets/products-landing-hero-mobile-750x380.jpg
// module id = 1109
// module chunks = 1